module.exports = __webpack_public_path__ + "img/circulateGreen.f6955409.png";